import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { useSessionStore } from "../store/sessionStore";
import { getLanguages } from "../services/loginSevices";
import { useTranslation } from "react-i18next";

export function useLanguages() {
  const { countryCode } = useSessionStore()
  const [t] = useTranslation("global")
  const languages = useQuery({
    queryKey: ["languages", countryCode],
    queryFn: () => getLanguages(countryCode),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !!countryCode
  });

  const transformToCustomOption = (options) => {
    if (Array.isArray(options)) {
      return options.map(item => ({
        value: item.language,
        name: t(`language.${item.language}`)
      }))
    }
  }

  return {
    languages: languages.data || [],
    languagesOptions: languages.data ? transformToCustomOption(languages.data) : [],
    isLoadingLanguages: languages.isLoading,
  };
}
